export enum TicketVolumeDataType {
    SingleDay = 1,
    Daily ,
    Weekly,
    Monthly,
    Quarterly,
    Annually,
    Custom
}
